module.exports = __webpack_public_path__ + "img/py.d3e57b21.svg";